import { atomWithStorage, createJSONStorage } from "jotai/utils";

import type { AnimationLevel, ThemeName } from "../types";

export interface AppState {
  theme: ThemeName;
  animation: AnimationLevel;
  timeZone: string;
  highContrast: boolean;
  shortcuts: boolean;
  sidebarOpen: boolean;
}

export const PREFERENCE_DEFAULTS = {
  theme: "system",
  animation: "normal",
  timeZone: "system",
  highContrast: false,
  shortcuts: true,
} as const satisfies Omit<AppState, "sidebarOpen">;

const initialState: AppState = {
  ...PREFERENCE_DEFAULTS,
  sidebarOpen: true,
};

const syncStorage = createJSONStorage<AppState>(() => localStorage);

export const appAtom = atomWithStorage<AppState>(
  "app",
  initialState,
  syncStorage,
  {
    // Reads storage synchronously during atom initialization
    getOnInit: true,
  },
);
